import React from 'react';

import { useGetSiteManagementLocations } from '@occc-app/dataAccessLayer/location/queries';

import LocationList from './LocationList';
import { LocationListContainerProps } from './types';
import { useSiteManagementLocationsSorting } from './use-site-management-locations-sorting.hook';

export const LocationListContainer = (props: LocationListContainerProps) => {
  const { filter, paginationInfo, onPageChange, renderEmpty, ...otherProps } = props;

  const { sort, sortingValue, toggleSorting } = useSiteManagementLocationsSorting();

  const locationsData = useGetSiteManagementLocations({
    filter,
    sort,
    paginationInfo,
    onPageChange,
  });

  return (
    <LocationList
      {...otherProps}
      locationsData={locationsData}
      renderEmpty={renderEmpty}
      sortingValue={sortingValue}
      onToggleSort={toggleSorting}
    />
  );
};
